import { MachineType } from '@internal/utils/machine/MachineType'
import { localeNamespace } from '@internal/utils/machine/i18n/Locale'
import { SearchResultsParams } from '@internal/utils/routing/getSearchResultsUrl'
import { MachineTypeSelectFilter } from '@renderer-ui-library/molecules'
import { useSearchParams } from 'blocks/SearchResultsBlock/useSearchParams'
import { useSearchResultsRouting } from 'blocks/SearchResultsBlock/useSearchResultsRouting'
import { translations } from 'i18n/translations'
import { useTranslation } from 'next-i18next'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { tracker } from 'utils/tracking/tracker'
import { SearchFilterCategory } from './SearchFilterCategory/SearchFilterCategory'

export const MachineTypeFilter: React.FC = React.memo(() => {
  const searchParams = useSearchParams()
  const searchParamsRef = useRef<SearchResultsParams>(searchParams)
  searchParamsRef.current = searchParams

  const { gotoSearchResults } = useSearchResultsRouting()
  const { t } = useTranslation(localeNamespace.common)

  const [newMachineType, setNewMachineType] = useState<MachineType | null>(
    searchParams.machineType ?? null
  )

  useEffect(() => {
    setNewMachineType(searchParams.machineType ?? null)
  }, [searchParams.machineType])

  const handleMachineTypeChange = useCallback(
    (machineType: MachineType | null) => {
      setNewMachineType(machineType)
      gotoSearchResults(
        {
          ...searchParamsRef.current,
          machineType: machineType ?? undefined,
          machineSubType: undefined,
        },
        false // no shallow routing, to get filters from backend
      )
      tracker.trackEvent({
        name: 'filter-applied',
        filter_placement: 'serp',
        filter_category: 'machine-type',
        filter_machine_type: machineType ?? 'any',
        is_interaction: true,
      })
    },
    [gotoSearchResults, searchParamsRef]
  )

  return (
    <SearchFilterCategory
      title={t(translations.searchResultsFiltersMachineTypeLabel)}
    >
      <MachineTypeSelectFilter
        selectedMachineType={newMachineType}
        onChange={handleMachineTypeChange}
      />
    </SearchFilterCategory>
  )
})

MachineTypeFilter.displayName = 'MachineTypeFilter'
